import React, { useContext, useEffect } from "react"
import { DialogTitle, Typography, DialogContent, BackIcon, Button } from "@carrotfertility/carotene-core"
import { DialogActionsBar } from "@carrotfertility/carotene-core-x"
import { FormattedMessage } from "react-intl"
import { TelemedicineDialogContext } from "#/components/telemedicine/EnterTelemedicineForMenopauseDialog"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useTelemedicineInterest } from "#/components/telemedicine/hooks/useTelemedicineInterest"

export function NotEligibleStep(): JSX.Element {
  const { back } = useStateMachine(null)
  const { setOpenDialogFlow } = useContext(TelemedicineDialogContext)
  const { mutate: createTelemedicineInterest } = useTelemedicineInterest()

  useEffect(() => {
    createTelemedicineInterest()
  }, [createTelemedicineInterest])

  return (
    <>
      <DialogTitle>
        <FormattedMessage defaultMessage="Not eligible" />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage defaultMessage="We're sorry, you are not eligible to use telemedicine services at this time, but we've noted your interest and will be in touch with any updates." />
        </Typography>
      </DialogContent>
      <DialogActionsBar
        primaryAction={
          <Button onClick={() => setOpenDialogFlow(false)}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        }
        tertiaryAction={
          <Button color="secondary" onClick={back} variant="text" startIcon={<BackIcon />}>
            <FormattedMessage defaultMessage="Back" />
          </Button>
        }
      />
    </>
  )
}
